














import { EMAIL_REGEX, LOADER_DELAY } from '@/constants';
import { TokenResponse } from '@/services/auth/types';
import auth from '@/services/auth';
import SectionBlog from './SectionBlog.vue';
import SectionFeatures from './SectionFeatures.vue';
import SectionFooter from './SectionFooter.vue';
import SectionHeader from './SectionHeader.vue';
import SectionSlides from './SectionSlides.vue';
import common from './common';

export default {
  mounted() {
    this.redirectOnLogin
      && this.signup();
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    // redirect to dashboard if logged in already
    auth.getCurrentToken()
      ? next('/dashboard')
      : next();
  },
  data() {
    return {
      redirectOnLogin: this.$route.query.r,
    };
  },
  computed: {
    redirectPath() {
      return this.redirectOnLogin
        ? { path: this.redirectOnLogin }
        : { name: 'dashboard' };
    },
  },
  methods: {
    signup() {
      const CTA = 'Signup / Login';

      // this constant also used in the email confirm function
      const redirectPath = this.redirectPath;

      return this.$store.commit('dialog/CREATE', {
        compact: true,
        component: {
          created() {
            this.emailConfirm = common.emailConfirm.bind(this);
            this.signupError = common.signupError.bind(this);
          },
          data: () => ({
            email: '',
            message: '',
            redirectPath,
          }),
          methods: {
            signup() {
              if (!EMAIL_REGEX.test(this.email)) {
                this.message = 'Invalid email address';
                this.$el.querySelector('input').focus();
                return;
              }

              this.$store.commit('loader/ADD', {
                title: 'Checking account details',
                promise: this.$store
                  .dispatch('auth/attemptLogin', this.email)
                  .then((response: TokenResponse) => {
                    // if token returned, we know a new user was created
                    response.token
                      ? this.$router.push(redirectPath)
                      : this.emailConfirm();
                  })
                  .catch(this.signupError),
              });

              // hide signup dialog behind loader to
              // reduce rendering performance degradation
              setTimeout(() => {

                // call dialog component to remove dialog matching
                // the CTA of the signup dialog. Protection incase
                // another dialog exists on page
                this.$parent.REMOVE(
                  this.$parent.dialogs.find((dialog: any) => (
                    dialog.buttons[0].text === CTA
                  )).id,
                );
              }, LOADER_DELAY);
            },
          },
          template: `
            <div style="max-width: 290px; padding: 0;">
              <input
                v-model="email"
                @keyup="message = ''"
                @keyup.enter="signup"
                placeholder="Email address"
                aria-label="Email address"
                style="width: 100%; margin: auto; padding: 20px 10px;" />
              <transition name="transition fade-down">
                <p class="error" v-if="message">{{ message }}</p>
              </transition>
            </div>
          `,
        } as IView,
        buttons: [
          {
            text: CTA,
            click: (dialog: any) => dialog.component[0].signup(),
          },
          {
            text: 'Close',
            click: (dialog: any) => dialog.close(),
          },
        ],
      });
    },
  },
  components: {
    SectionBlog,
    SectionFeatures,
    SectionFooter,
    SectionHeader,
    SectionSlides,
  },
} as IView;
